import { useState, useEffect } from "react";
import axios from "axios";
import ApplyModal from "./ApplyModal";
import "./careers.css";

export default function OpenJobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");

  // Fetch jobs from MongoDB via your Backend API
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get("https://meetra-green-energy-backend.onrender.com/api/openings");
        // Filter to only show jobs
        const onlyJobs = response.data.filter((item) => item.type === "job");
        setJobs(onlyJobs);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching jobs:", error);
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  const openModal = (title) => {
    setSelectedJob(title);
    setIsModalOpen(true);
  };

  return (
    <div className="career-page">
      <h1>Open Jobs</h1>
      <p>Build your career with us in the renewable energy sector 🌱</p>

      {loading ? (
        <p>Loading vacancies...</p>
      ) : jobs.length > 0 ? (
        jobs.map((job) => (
          <div className="job-card" key={job._id}>
            <h3>{job.title}</h3>
            <p><strong>Location:</strong> {job.location}</p>
            <p><strong>Experience:</strong> {job.experience}</p>
            <button onClick={() => openModal(job.title)}>
              Apply Now
            </button>
          </div>
        ))
      ) : (
        <p>No active job openings at the moment. Check back soon!</p>
      )}

      {/* APPLY MODAL */}
      <ApplyModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        jobTitle={selectedJob}
      />
    </div>
  );
}